module.exports = __webpack_public_path__ + "img/logoInh.d225612d.png";